<template>
  <div class="add-answer-btn-box clickable">
    <slot></slot>
  </div>
</template>

<script>
  export default {
    name: 'add-answer-button',
  };
</script>



// WEBPACK FOOTER //
// src/app/my-cards/components/AddAnswerButton.vue